<template>
  <div class="main fc ac">
    <img style="width: 100%;" src="../../assets/volunteer/头部.png" alt />

    <van-tabs v-model="active" color="#FB5363" type="card">
      <van-tab title="使用方法">
        <div>
          <div
            class="sj p20 mt20"
            style="font-weight:blob;"
          >自动体外除颤器又称自动体外电击器，是可被非专业人员使用的用于抢救心源性猝死患者的设备。</div>

          <div class="fr jc ac mt20">
            <img style="width:246px;height:226px" src="../../assets/AED/使用说明.png" alt />
          </div>
        </div>
      </van-tab>
      <van-tab title="AED地图">
        <div class="amap-page-container">
          <el-amap
            ref="map"
            vid="amapDemo"
            :amap-manager="amapManager"
            :center="center"
            :zoom="zoom"
            :plugin="plugin"
            :events="events"
            class="amap-demo"
          >
            <!-- 标记 -->
            <el-amap-marker
              v-for="(marker, index) in markers"
              :key="index"
              :position="marker.position"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
              :vid="index"
              :icon="marker.icon"
            ></el-amap-marker>
            <el-amap-marker :position="[lng,lat]" :visible="true"></el-amap-marker>
          </el-amap>

          <!-- 信息弹窗 -->

          <van-popup v-model="showMarker" position="bottom" :overlay="false">
            <div class="address-info">
              <div style="display: flex;justify-content: flex-end;align-items: center;">
                <img
                  @click="closeMarker"
                  style="display: inline-block;width: 10px;height: 10px;;"
                  src="../../assets/AED/close.png"
                  alt
                />
              </div>

              <div
                class="fr jsb ac"
                style="color:white;border-bottom:1px dashed #fff;padding-bottom: 20px;"
              >
                <div>
                  <div class="fz20">{{aed.street}}</div>
                  <div class="fz10 mt10">{{aed.address}}</div>
                </div>

                <div class="fz14">{{aed.dis}}公里</div>
              </div>

              <van-grid :border="false" :column-num="3">
                <van-grid-item>
                  <div>{{aed.device_status}}</div>
                  <div class="fz8 mt6">当前状态</div>
                </van-grid-item>
                <van-grid-item>
                  <div>{{aed.external_status}}</div>
                  <div class="fz8 mt6">对外公开</div>
                </van-grid-item>
                <van-grid-item>
                  <div class="fz12" style="text-align:center">{{aed.open_time}}</div>
                  <div class="fz8 mt6">营业时间</div>
                </van-grid-item>
              </van-grid>
            </div>

            <div class="device-info">
              <div class="fz12">仪器编号: {{aed.device_no}}</div>
              <div class="fz12 mt4">设备品牌: {{aed.device_brand}}</div>
              <div class="fz12 mt4">设备机型: {{aed.device_model}}</div>
              <div class="fz12 mt4">外箱机型: {{aed.outer_type}}</div>
              <div class="fz12 mt4">所属单位: {{aed.company_name}}</div>
            </div>
          </van-popup>
        </div>
      </van-tab>
    </van-tabs>

    <img
      v-if="active!=1"
      class="bottom"
      style="width: 100%;height:98px"
      src="../../assets/volunteer/底部.png"
      alt
    />
  </div>
</template>

<script>
import { AMapManager, lazyAMapApiLoaderInstance, VueAMap } from "vue-amap";
import { Toast } from "vant";

let amapManager = new AMapManager();

export default {
  name: "home",
  data() {
    let self = this;
    return {
      //显示信息弹窗
      showMarker: false,
      active: 1,
      amapManager,
      zoom: 10,
      lng: 0,
      lat: 0,
      loaded: false,
      center: [121.50325, 31.403735],
      events: {
        init: o => {
          // console.log(o.getCenter());
          //   console.log(this.$refs.map.$$getInstance());
          o.getCity(result => {
            // console.log(result);
          });
        },
        moveend: () => {},
        zoomchange: () => {},
        click: e => {}
      },
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(status, result);
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            }
          }
        }
      ],

      //   标注
      markers: [],
      // 当前aed
      aed: {}
    };
  },
  components: {},
  mounted() {
    setTimeout(() => {
      this.getAEDList();
    }, 1000);
  },
  methods: {
    getAEDList() {
      this.post("aed/getList").then(res => {
        let aed_list = res.data;

        aed_list.forEach(item => {
          let show = this.showMarkerDetail;
          item.position = [item.lon, item.lat];
          item.visible = true;
          item.events = {
            click() {
              show(item);
            }
          };
          item.icon = "http://img.baoshanhszh.cn/%E7%BB%BF%E7%9A%84.png";
          if (item.external_status == "全公开") {
            // console.log("全公开");
            item.icon = "http://img.baoshanhszh.cn/%E7%BB%BF%E7%9A%84.png";
          }
          if (item.external_status == "半公开") {
            // console.log("半公开");
            item.icon = "http://img.baoshanhszh.cn/%E7%BA%A2%E7%9A%84.png";
          }
        });

        this.markers = aed_list;
      });
    },
    getMap() {},
    //显示左边详情
    showMarkerDetail(item) {
      // console.log(item);

      try {
        var dis = AMap.GeometryUtil.distance(
          [this.lng, this.lat],
          item.position
        );
        item.dis = (dis / 1000).toFixed(2);
      } catch {
        item.dis = 0.28;
      }

      this.aed = item;
      this.showMarker = true;
    },
    closeMarker() {
      this.showMarker = false;
    }
  }
};
</script>


<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  height: 100vh;

  //   background-image: url("./../../assets/index/bg.png");
  background-size: contain;
  background-color: #fffafa;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}

/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title {
  font-weight: bold;
}

/deep/ .van-tabs {
  width: 100%;
}
/deep/.van-tabs__nav--card {
  margin: 0;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 98px;
}
.amap-demo {
  height: 86vh;
}

.van-popup {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  bottom: 4vw;
  left: 4vw;
  width: 92vw;
}
.address-info {
  padding: 10px;
  // height: 185px;
  background-color: #249aed;
}
.device-info {
  padding: 16px;
  // height: 100px;
  background-color: #fff;
}
/deep/ .van-grid-item__content {
  background-color: #249aed;

  color: white;
}

/deep/.amap-icon img {
  width: 18px;
  height: 27px;
}
</style>